export const SET_LOADING = 'APP_STATE::SET_LOADING'
